export enum ErrorTypes {
  GENERIC = 'GENERIC',
  UNAUTHENTICATED = 'UNAUTHENTICATED',
}